import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  activationCode: faker.number.int(),
  cancelRecurringMeeting: false,
  connectedEmailAccount: null,
  hasConnectedCalendarAccount: false,
  provider: null,
  authErrorType: '',
  authErrorMsg: '',
});
